import { Fragment } from 'react';
import { arrayOf, node, oneOfType } from 'prop-types';

import styles from './Title.scss';

export const Title = ({ children = null, ...props }) => (
  <Fragment>
    <h3 className={styles.Title} data-testid="SectionTitle" {...props}>
      {children}
    </h3>
  </Fragment>
);

Title.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
};
